module.exports = __webpack_public_path__ + "img/center_reight.07aa91e2.svg";